/* JS stuff for the communities listing page */

export function archive_communities() {
	( ( $ ) => {

		if ( $( 'body.page-all-destinations' ).length <= 0 ) {
			return;
		}

		// const click_map_pin = () => {

		// 	if ( 'object' !== typeof FWP ) {
		// 		return;
		// 	}

		// 	FWP.hooks.addAction( 'facetwp_map/marker/click', ( marker ) => {
		// 		const card_id = `#card-community-${marker.post_id}`;
		// 		const item_position = marker.uniqueID;

		// 		const page = Math.ceil( item_position / FWP.settings.pager.per_page );

		// 		FWP.paged = page;
		// 		FWP.setHash();
		// 		FWP.refresh();

		// 		$( document ).one( 'facetwp-loaded', () => {
		// 			const target_position = parseInt( $( card_id ).offset().top - ( window.COVE.navbar_total_height + 30 ) );

		// 			$( 'html, body' ).animate( {
		// 				scrollTop: target_position
		// 			} );
		// 		} );
		// 	} );
		// }

		// click_map_pin();


		// Map show/hide
		if ( $( '.results-view-mode' ).length > 0 ) {

			const apply_view_mode = ( ev ) => {
				const view_active = $( '.results-view-mode' ).find( 'input[type="radio"]:checked' );

				if ( 'results-view-mode--map' == view_active.prop( 'id' ) ) {
					$( '#map-cards-results--column-cards' )
						.removeClass( 'col-lg' )
						.addClass( 'col-lg-6' );

					$( '#map-cards-results--column-cards' ).find( '.facetwp-template > .col-lg-3' ).each( ( ind, ele ) => {
						$( ele )
							.removeClass( 'col-lg-3' )
							.addClass( 'col-lg-6' );
					} );

					$( '#map-area' ).removeClass( 'd-none' );

				} else if ( 'results-view-mode--list' == view_active.prop( 'id' ) ) {
					$( '#map-cards-results--column-cards' )
						.removeClass( 'col-lg-6' )
						.addClass( 'col-lg' );

					$( '#map-cards-results--column-cards' ).find( '.facetwp-template > .col-lg-6' ).each( ( ind, ele ) => {
						$( ele )
							.removeClass( 'col-lg-6' )
							.addClass( 'col-lg-3' );
					} );

					$( '#map-area' ).addClass( 'd-none' );
				}
			}

			$( '.results-view-mode input[type="radio"]' ).on( 'click', apply_view_mode );

			$( document ).on( 'facetwp-loaded', apply_view_mode );
		}


	} )( window.jQuery );
}
